var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',_vm._g(_vm._b({staticClass:"d-inline-block",attrs:{"href":"https://uptrace.dev/","target":"_blank"}},'a',_vm.$attrs,false),_vm.$listeners),[_c('v-img',{staticClass:"shrink",attrs:{"src":"/uptrace/logo-small.svg","max-width":_vm.width,"width":_vm.width,"transition":"scale-transition","alt":"Uptrace"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }